// MAC ↔ URL slug conversion for device deep-links.
//
// RTDB stores device keys with colons (e.g. "D0:76:58:5A:46:8C"), but ":"
// is reserved in URL paths and would be percent-encoded as %3A — ugly and
// fragile. Wasabi storage paths already use the underscore form, so we
// adopt the same convention for our dashboard URLs.
//
//   macToSlug("D0:76:58:5A:46:8C") → "D0_76_58_5A_46_8C"
//   slugToMac("D0_76_58_5A_46_8C") → "D0:76:58:5A:46:8C"
//
// Both functions are tolerant: passing a value that is already in the
// target form returns it unchanged. This way callers never have to track
// which form they're currently holding.

/**
 * Convert a MAC address (colon form) to its URL-safe slug (underscore form).
 * @param {string} mac e.g. "D0:76:58:5A:46:8C"
 * @returns {string} e.g. "D0_76_58_5A_46_8C"
 */
export function macToSlug(mac) {
    if (!mac) return mac;
    return String(mac).replace(/:/g, '_');
}

/**
 * Convert a URL slug back to a MAC address (colon form) for RTDB lookups.
 * @param {string} slug e.g. "D0_76_58_5A_46_8C"
 * @returns {string} e.g. "D0:76:58:5A:46:8C"
 */
export function slugToMac(slug) {
    if (!slug) return slug;
    return String(slug).replace(/_/g, ':');
}
